import {
  Input,
  InputText,
  Textarea,
  // Stepper,
  Email,
  // Hidden,
  Select,
  // SelectCert,
  // SelectAsync,
  // PickerStack,
  Radio,
  // RadioPerson,
  Checkbox,
  // Date,
  // Upload, // 有问题
  // UploadCertificate, // 有问题
  // Smscode, // 有问题
  // AgreeTerms, // 有问题
  // Value,
  // ValueChilds,
  // ValuePrice,
  // Button,
  // Submit,
  // ButtonGroup,

} from '../index';

const componentConfig = {
  // 输入框
  input: Input,
  // 段落输入框
  'input-text': InputText,
  // 多行输入
  textarea: Textarea,
  // 步进器
  // stepper: Stepper,
  // 邮箱
  email: Email,
  // 隐藏框
  // hidden: Hidden,
  // 选择器
  select: Select,
  // 选择器证件
  // 'select-cert': SelectCert,
  // 选择器，请求接口
  // 'select-async': SelectAsync,
  // 选择器堆栈
  // 'picker-stack': PickerStack,
  // 单选框
  radio: Radio,
  // 受益人
  // 'radio-person': RadioPerson,
  // 多选框
  checkbox: Checkbox,
  // 基本日期
  date: Date,
  // 上传文件
  // upload: Upload,
  // // 上传证件
  // 'upload-certificate': UploadCertificate,
  // // 验证码
  // smscode: Smscode,
  // // 协议
  // 'agree-terms': AgreeTerms,
  // // 纯文字
  // value: Value,
  // // 子级列表文字
  // 'value-childs': ValueChilds,
  // // 文字价格
  // 'value-price': ValuePrice,
  // // 按钮
  // button: Button,
  // // 按钮-提交
  // submit: Submit,
  // // 按钮组
  // 'button-group': ButtonGroup,

};

export default componentConfig;
